import numeral from 'numeral';

function formatPin(pin = '') {
  const reversePin = +pin
    .split('')
    .reverse()
    .join('');
  return numeral(reversePin)
    .format('0,0')
    .split('')
    .reverse()
    .join('')
    .replace(/,/g, ' ');
}

export default formatPin;
